import React, { Component, type ComponentType } from 'react'

import type { TargetStatusUpdates } from '../campaigns/campaignTargets'

export interface Payload {
  id: string
  name: string
  status: string
}

export interface ActionButtonProps {
  addPaused: (data: Payload) => void
  addRunning: (data: Payload) => void
  data: Omit<Payload, 'id'> & { companyUuid: string }
  updates: TargetStatusUpdates
}

export default <P extends object>(DecoratedComponent: ComponentType<P>) =>
  class extends Component<P & ActionButtonProps> {
    isActive = () => {
      const {
        data: { companyUuid, status },
        updates,
      } = this.props
      return updates.get('running')?.has(companyUuid)
        ? true
        : updates.get('paused')?.has(companyUuid)
          ? false
          : status === 'RUNNING'
    }

    handleAddPaused = (payload: Payload) => () => this.props.addPaused(payload)

    handleAddRunning = (payload: Payload) => () => this.props.addRunning(payload)

    render() {
      const {
        data: { companyUuid, name, status },
      } = this.props

      const isActive = this.isActive()
      const payload = { id: companyUuid, name, status }

      const onClick = isActive ? this.handleAddPaused(payload) : this.handleAddRunning(payload)

      return <DecoratedComponent {...this.props} isActive={isActive} onClick={onClick} />
    }
  }
